<template>
  <div class="ka-pc-card">
    <h3 class="ka-pc-card-title">{{ t.comparisonTitle }}</h3>
    <div v-for="comp in items" :key="comp.code" class="ka-pc-stat">
      <div class="ka-pc-stat-label">{{ comp.name }}</div>
      <div class="ka-pc-stat-row">
        <span class="ka-pc-stat-value">{{ comp.formatted }}</span>
        <span
          v-if="comp.change"
          :class="['ka-pc-badge', comp.changeClass]"
        >{{ comp.change }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComparisonCard',
  props: {
    t: { type: Object, required: true },
    items: { type: Array, required: true }
  }
}
</script>
